/*
  QQ: lead-time notice (see snippets/product__form.liquid).
  Shows [data-qq-lead-time] when the selected variant is one of its no-stock variants and
  the product has no Pre-Order Date or it is before today (store time, Africa/Johannesburg).
*/
(function () {
  if (window.qqLeadTimeNotice) return;
  window.qqLeadTimeNotice = true;

  function today() {
    try {
      // en-CA formats as YYYY-MM-DD
      return new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Johannesburg' });
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function update(notice, variantId) {
    var noStock = (notice.getAttribute('data-no-stock-variants') || '').split(',');
    // No Pre-Order Date counts as passed; a date still ahead means an open pre-order
    var preorderDate = notice.getAttribute('data-preorder-date') || '';
    var preorderPassed = preorderDate === '' || preorderDate < today();
    notice.hidden = !(preorderPassed && variantId && noStock.indexOf(String(variantId)) !== -1);
  }

  function noticeFor(el) {
    var form = el.closest('[data-product-form]');
    return form ? form.querySelector('[data-qq-lead-time]') : null;
  }

  // variant-change doesn't bubble, so listen in the capture phase
  document.addEventListener('variant-change', function (event) {
    var notice = noticeFor(event.target);
    if (!notice) return;
    var variant = event.detail && event.detail.variant;
    update(notice, variant ? variant.id : null);
  }, true);

  // Re-check on load so a cached page still respects today's date
  function init() {
    document.querySelectorAll('[data-qq-lead-time]').forEach(function (notice) {
      var form = notice.closest('[data-product-form]');
      var idInput = form && form.querySelector('[name="id"]');
      update(notice, idInput ? idInput.value : null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
